import type { IntlShape } from 'react-intl'

import type { Locale } from '@app/constants/Locales'

import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

import { intlSlice } from './intl'

const localeSlice = createReduxSlice<Locale>('locale')

export const localeSelector = createSelector([localeSlice.selector], locale => locale ?? 'ru')

/** The locale and its intl move together — one without the other renders half the UI in the wrong language. */
export const setLocaleSlice = (locale: Locale, intl: IntlShape) =>
  createThunk(dispatch => {
    dispatch(intlSlice.set(intl))
    dispatch(localeSlice.set(locale))
  })
